import {
  Component, EventEmitter,
  HostBinding,
  Input, OnInit, Output,
} from '@angular/core';
import {InputComponent} from '@lib-modules/input/components/input/input.component';
import { ColorScheme } from '@lib/models/color-scheme/color-scheme';
import { LayoutService } from '@utils/services/layout/layout.service';
import {debounceTime, distinctUntilChanged, tap} from 'rxjs/operators';

export enum SearchLayout {
  Default = "default",
  Flat = "flat",
}
@Component({
  selector: 'lib-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent extends InputComponent implements OnInit {

  @Input() public debounceTime = 300;
  @Input() public focusOnInit = false;
  @Input() public searching = false;
  @Input() public showSearchButton = true;
  @Input() public searchButtonPosition: "left" | "right" = "left";
  @Input() public colorScheme: ColorScheme;
  @Input() public layout = SearchLayout.Default;
  @Output() public search = new EventEmitter<string>();
  @HostBinding('class.flat') private flatLayout = false;

  constructor() {
    super();
  }

  public ngOnInit() {
    this.flatLayout = this.layout === SearchLayout.Flat;
    this.inputControl.valueChanges.pipe(
      debounceTime(this.debounceTime),
      distinctUntilChanged(),
      tap((query: string) => this.search.emit(query))
    ).subscribe();
  }

  public reset() {
    this.inputControl.setValue("", { emitEvent: false });
  }
}
